import { AxiosResponse } from 'axios';

import { instance as axios } from '../../api/axios';
import { Peripherals } from './interfaces';

export class PeripheralsService {
  public static async getPeripherals(sgid: string) {
    const branchLocal = localStorage.getItem('branchId') || 'null';
    const branchId = JSON.parse(branchLocal)?.id;
    try {
      const url = `/Peripherals?sgid=${sgid}&branchId=${branchId}`;
      const response: AxiosResponse<Peripherals> = await axios.get(url);

      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }
}
